import type { IconProps } from '@/ui/Icons/IconProps';

export const Level0ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 112}
    height={props.height ?? 58}
    style={props.style}
    viewBox="0 0 112 58"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20675)">
      <path
        d="M5.6 56C2.5072 56 -0.0290604 53.4865 0.27961 50.4091C1.5634 37.6103 7.22611 25.5779 16.402 16.402C26.9041 5.89998 41.1479 1.1213e-06 56 0C70.8521 -1.1213e-06 85.0959 5.89998 95.598 16.402C104.774 25.5779 110.437 37.6103 111.72 50.4091C112.029 53.4865 109.493 56 106.4 56C103.307 56 100.836 53.483 100.451 50.4144C99.2166 40.5922 94.7525 31.3958 87.6784 24.3216C79.2767 15.92 67.8817 11.2 56 11.2C44.1183 11.2 32.7232 15.92 24.3216 24.3216C17.2475 31.3958 12.7834 40.5922 11.5494 50.4144C11.1639 53.483 8.69279 56 5.6 56Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_i_5008_20675)">
      <path
        d="M5.6 56C2.5072 56 -0.0289993 53.4866 0.27977 50.4093C0.492569 48.2884 0.826286 46.1814 1.27929 44.0986C1.93658 41.0764 5.12533 39.4698 8.06675 40.4255C11.0082 41.3813 12.5807 44.5385 11.9991 47.5761C11.8189 48.5172 11.669 49.4638 11.5495 50.4145C11.164 53.4832 8.69279 56 5.6 56Z"
        fill="url(#paint0_linear_5008_20675)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20675"
        x="0.25412"
        y="0"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20675" />
      </filter>
      <filter
        id="filter1_i_5008_20675"
        x="0.254272"
        y="40.1504"
        width="11.8646"
        height="15.8496"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20675" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20675"
        x1="-28"
        y1="112"
        x2="128"
        y2="-12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F55E66" />
        <stop offset="1" stopColor="#F55E66" stopOpacity="0.7" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level1ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 112}
    height={props.height ?? 58}
    style={props.style}
    viewBox="0 0 112 58"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20674)">
      <path
        d="M5.6 56C2.5072 56 -0.0290604 53.4865 0.27961 50.4091C1.5634 37.6103 7.22611 25.5779 16.402 16.402C26.9041 5.89998 41.1479 1.1213e-06 56 0C70.8521 -1.1213e-06 85.0959 5.89998 95.598 16.402C104.774 25.5779 110.437 37.6103 111.72 50.4091C112.029 53.4865 109.493 56 106.4 56C103.307 56 100.836 53.483 100.451 50.4144C99.2166 40.5922 94.7525 31.3958 87.6784 24.3216C79.2767 15.92 67.8817 11.2 56 11.2C44.1183 11.2 32.7232 15.92 24.3216 24.3216C17.2475 31.3958 12.7834 40.5922 11.5494 50.4144C11.1639 53.483 8.69279 56 5.6 56Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_i_5008_20674)">
      <path
        d="M5.6 56C2.5072 56 -0.0289993 53.4866 0.27977 50.4093C0.492569 48.2884 0.826286 46.1814 1.27929 44.0986C1.93658 41.0764 5.12533 39.4698 8.06675 40.4255C11.0082 41.3813 12.5807 44.5385 11.9991 47.5761C11.8189 48.5172 11.669 49.4638 11.5495 50.4145C11.164 53.4832 8.69279 56 5.6 56Z"
        fill="url(#paint0_linear_5008_20674)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20674"
        x="0.25412"
        y="0"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20674" />
      </filter>
      <filter
        id="filter1_i_5008_20674"
        x="0.254257"
        y="40.1504"
        width="11.8646"
        height="15.8496"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20674" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20674"
        x1="-28"
        y1="112"
        x2="128"
        y2="-12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F55E66" />
        <stop offset="1" stopColor="#F55E66" stopOpacity="0.7" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level2ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 112}
    height={props.height ?? 58}
    style={props.style}
    viewBox="0 0 112 58"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20682)">
      <path
        d="M5.6 56C2.5072 56 -0.0290604 53.4865 0.27961 50.4091C1.5634 37.6103 7.22611 25.5779 16.402 16.402C26.9041 5.89998 41.1479 1.1213e-06 56 0C70.8521 -1.1213e-06 85.0959 5.89998 95.598 16.402C104.774 25.5779 110.437 37.6103 111.72 50.4091C112.029 53.4865 109.493 56 106.4 56C103.307 56 100.836 53.483 100.451 50.4144C99.2166 40.5922 94.7525 31.3958 87.6784 24.3216C79.2767 15.92 67.8817 11.2 56 11.2C44.1183 11.2 32.7232 15.92 24.3216 24.3216C17.2475 31.3958 12.7834 40.5922 11.5494 50.4144C11.1639 53.483 8.69279 56 5.6 56Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_i_5008_20682)">
      <path
        d="M5.6 56C2.5072 56 -0.0290298 53.4865 0.279724 50.4092C1.08088 42.424 3.58972 34.7026 7.63516 27.7715C9.19419 25.1004 12.7234 24.5577 15.2255 26.3756C17.7277 28.1935 18.2474 31.6823 16.7557 34.3915C14.0228 39.3548 12.2559 44.7926 11.5495 50.4144C11.1639 53.4831 8.69279 56 5.6 56Z"
        fill="url(#paint0_linear_5008_20682)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20682"
        x="0.254116"
        y="0"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20682" />
      </filter>
      <filter
        id="filter1_i_5008_20682"
        x="0.254215"
        y="25.3115"
        width="17.3327"
        height="30.6885"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20682" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20682"
        x1="-28"
        y1="112"
        x2="128"
        y2="-12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F55E66" />
        <stop offset="1" stopColor="#F55E66" stopOpacity="0.7" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level3ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 114}
    height={props.height ?? 59}
    style={props.style}
    viewBox="0 0 114 59"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20681)">
      <path
        d="M7.6 56C4.5072 56 1.97094 53.4865 2.27961 50.4091C3.5634 37.6103 9.22611 25.5779 18.402 16.402C28.9041 5.89998 43.1479 1.1213e-06 58 0C72.8521 -1.1213e-06 87.0959 5.89998 97.598 16.402C106.774 25.5779 112.437 37.6103 113.72 50.4091C114.029 53.4865 111.493 56 108.4 56C105.307 56 102.836 53.483 102.451 50.4144C101.217 40.5922 96.7525 31.3958 89.6784 24.3216C81.2767 15.92 69.8817 11.2 58 11.2C46.1183 11.2 34.7232 15.92 26.3216 24.3216C19.2475 31.3958 14.7834 40.5922 13.5494 50.4144C13.1639 53.483 10.6928 56 7.6 56Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_di_5008_20681)">
      <path
        d="M7.6 56C4.5072 56 1.97099 53.4866 2.27976 50.4092C2.97197 43.5104 4.94118 36.7832 8.10364 30.5765C11.2661 24.3699 15.551 18.8226 20.7254 14.2075C23.0336 12.1489 26.5577 12.7234 28.3756 15.2255C30.1935 17.7277 29.6099 21.2062 27.3539 23.3219C23.5833 26.8581 20.4425 31.0302 18.0829 35.6612C15.7233 40.2922 14.1941 45.2855 13.5495 50.4145C13.1639 53.4832 10.6928 56 7.6 56Z"
        fill="url(#paint0_linear_5008_20681)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20681"
        x="2.25411"
        y="0"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20681" />
      </filter>
      <filter
        id="filter1_di_5008_20681"
        x="0.298809"
        y="11.6515"
        width="31.1077"
        height="46.9558"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5008_20681" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5008_20681"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5008_20681" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20681"
        x1="105"
        y1="19.5"
        x2="44.5"
        y2="112"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB22D" />
        <stop offset="1" stopColor="#FF963A" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level4ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 114}
    height={props.height ?? 59}
    style={props.style}
    viewBox="0 0 114 59"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20680)">
      <path
        d="M7.6 56C4.5072 56 1.97094 53.4865 2.27961 50.4091C3.5634 37.6103 9.22611 25.5779 18.402 16.402C28.9041 5.89998 43.1479 1.1213e-06 58 0C72.8521 -1.1213e-06 87.0959 5.89998 97.598 16.402C106.774 25.5779 112.437 37.6103 113.72 50.4091C114.029 53.4865 111.493 56 108.4 56C105.307 56 102.836 53.483 102.451 50.4144C101.217 40.5922 96.7525 31.3958 89.6784 24.3216C81.2767 15.92 69.8817 11.2 58 11.2C46.1183 11.2 34.7232 15.92 26.3216 24.3216C19.2475 31.3958 14.7834 40.5922 13.5494 50.4144C13.1639 53.483 10.6928 56 7.6 56Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_di_5008_20680)">
      <path
        d="M7.6 56C4.5072 56 1.97097 53.4865 2.27972 50.4092C3.26665 40.5724 6.84504 31.1359 12.695 23.084C18.5451 15.0322 26.4139 8.71288 35.4643 4.73452C38.2956 3.48993 41.4698 5.12533 42.4255 8.06675C43.3813 11.0082 41.7511 14.1361 38.9518 15.4511C32.14 18.651 26.215 23.53 21.756 29.6672C17.2971 35.8044 14.4878 42.9472 13.5495 50.4144C13.1639 53.4831 10.6928 56 7.6 56Z"
        fill="url(#paint0_linear_5008_20680)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20680"
        x="2.25412"
        y="0"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20680" />
      </filter>
      <filter
        id="filter1_di_5008_20680"
        x="0.298771"
        y="3.00985"
        width="44.3568"
        height="55.5974"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5008_20680" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5008_20680"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5008_20680" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20680"
        x1="105"
        y1="19.5"
        x2="44.5"
        y2="112"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB22D" />
        <stop offset="1" stopColor="#FF963A" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level5ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 114}
    height={props.height ?? 61}
    style={props.style}
    viewBox="0 0 114 61"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20684)">
      <path
        d="M7.6 58C4.5072 58 1.97094 55.4865 2.27961 52.4091C3.5634 39.6103 9.22611 27.5779 18.402 18.402C28.9041 7.89998 43.1479 2 58 2C72.8521 2 87.0959 7.89998 97.598 18.402C106.774 27.5779 112.437 39.6103 113.72 52.4091C114.029 55.4865 111.493 58 108.4 58C105.307 58 102.836 55.483 102.451 52.4144C101.217 42.5922 96.7525 33.3958 89.6784 26.3216C81.2767 17.92 69.8817 13.2 58 13.2C46.1183 13.2 34.7232 17.92 26.3216 26.3216C19.2475 33.3958 14.7834 42.5922 13.5494 52.4144C13.1639 55.483 10.6928 58 7.6 58Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_di_5008_20684)">
      <path
        d="M7.6 58C4.5072 58 1.971 55.4866 2.27977 52.4093C2.82521 46.9731 4.1643 41.6358 6.26275 36.5697C9.07701 29.7755 13.2019 23.6021 18.402 18.402C23.6021 13.2019 29.7755 9.07701 36.5697 6.26275C41.6358 4.1643 46.9731 2.82521 52.4093 2.27977C55.4866 1.971 58 4.50721 58 7.6C58 10.6928 55.4832 13.1639 52.4145 13.5495C48.4505 14.0477 44.5624 15.0749 40.8558 16.6102C35.4204 18.8616 30.4817 22.1616 26.3216 26.3216C22.1616 30.4817 18.8616 35.4204 16.6102 40.8558C15.0749 44.5624 14.0477 48.4505 13.5495 52.4145C13.1639 55.4832 10.6928 58 7.6 58Z"
        fill="url(#paint0_linear_5008_20684)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20684"
        x="2.25412"
        y="2"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20684" />
      </filter>
      <filter
        id="filter1_di_5008_20684"
        x="0.298832"
        y="0.950279"
        width="59.6566"
        height="59.657"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5008_20684" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5008_20684"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5008_20684" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20684"
        x1="105"
        y1="21.5"
        x2="44.5"
        y2="114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB22D" />
        <stop offset="1" stopColor="#FF963A" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level6ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 114}
    height={props.height ?? 61}
    style={props.style}
    viewBox="0 0 114 61"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20676)">
      <path
        d="M7.6 58C4.5072 58 1.97094 55.4865 2.27961 52.4091C3.5634 39.6103 9.22611 27.5779 18.402 18.402C28.9041 7.89998 43.1479 2 58 2C72.8521 2 87.0959 7.89998 97.598 18.402C106.774 27.5779 112.437 39.6103 113.72 52.4091C114.029 55.4865 111.493 58 108.4 58C105.307 58 102.836 55.483 102.451 52.4144C101.217 42.5922 96.7525 33.3958 89.6784 26.3216C81.2767 17.92 69.8817 13.2 58 13.2C46.1183 13.2 34.7232 17.92 26.3216 26.3216C19.2475 33.3958 14.7834 42.5922 13.5494 52.4144C13.1639 55.483 10.6928 58 7.6 58Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_di_5008_20676)">
      <path
        d="M7.6 58C4.5072 58 1.97099 55.4866 2.27976 52.4092C2.97197 45.5104 4.94118 38.7832 8.10364 32.5765C12.1157 24.7024 17.9344 17.8895 25.084 12.695C32.2336 7.50056 40.5111 4.07192 49.2397 2.68945C56.1198 1.59974 63.1263 1.80573 69.9014 3.27927C72.9235 3.93656 74.5302 7.12533 73.5745 10.0668C72.6187 13.0082 69.4614 14.5806 66.4238 13.9991C61.3466 13.0271 56.1252 12.9385 50.9917 13.7516C44.0089 14.8575 37.3869 17.6005 31.6672 21.756C25.9475 25.9116 21.2926 31.3619 18.0829 37.6612C15.7233 42.2922 14.1941 47.2855 13.5495 52.4145C13.1639 55.4832 10.6928 58 7.6 58Z"
        fill="url(#paint0_linear_5008_20676)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20676"
        x="2.25409"
        y="2"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20676" />
      </filter>
      <filter
        id="filter1_di_5008_20676"
        x="0.298832"
        y="0.696373"
        width="75.5063"
        height="59.9109"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5008_20676" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5008_20676"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5008_20676" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20676"
        x1="105"
        y1="21.5"
        x2="44.5"
        y2="114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#19DB15" />
        <stop offset="1" stopColor="#3CBD68" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level7ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 114}
    height={props.height ?? 61}
    style={props.style}
    viewBox="0 0 114 61"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20678)">
      <path
        d="M7.6 58C4.5072 58 1.97094 55.4865 2.27961 52.4091C3.5634 39.6103 9.22611 27.5779 18.402 18.402C28.9041 7.89998 43.1479 2 58 2C72.8521 2 87.0959 7.89998 97.598 18.402C106.774 27.5779 112.437 39.6103 113.72 52.4091C114.029 55.4865 111.493 58 108.4 58C105.307 58 102.836 55.483 102.451 52.4144C101.217 42.5922 96.7525 33.3958 89.6784 26.3216C81.2767 17.92 69.8817 13.2 58 13.2C46.1183 13.2 34.7232 17.92 26.3216 26.3216C19.2475 33.3958 14.7834 42.5922 13.5494 52.4144C13.1639 55.483 10.6928 58 7.6 58Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_di_5008_20678)">
      <path
        d="M7.6 58C4.5072 58 1.97099 55.4865 2.27975 52.4092C3.11909 44.0438 5.83431 35.9493 10.2522 28.7401C15.6483 19.9343 23.3745 12.7923 32.5765 8.10364C41.7785 3.41498 52.0979 1.36233 62.3937 2.17263C70.8229 2.83602 78.9674 5.39718 86.2285 9.63518C88.8996 11.1942 89.4423 14.7234 87.6244 17.2255C85.8065 19.7277 82.3178 20.2475 79.6085 18.7557C74.0495 15.6948 67.8838 13.8393 61.515 13.3381C53.2783 12.6899 45.0228 14.332 37.6612 18.0829C30.2996 21.8338 24.1187 27.5474 19.8017 34.5921C16.4637 40.0392 14.3407 46.118 13.5495 52.4145C13.1639 55.4831 10.6928 58 7.6 58Z"
        fill="url(#paint0_linear_5008_20678)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20678"
        x="2.25409"
        y="2"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20678" />
      </filter>
      <filter
        id="filter1_di_5008_20678"
        x="0.298832"
        y="0.696373"
        width="90.3446"
        height="59.9109"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5008_20678" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5008_20678"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5008_20678" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20678"
        x1="105"
        y1="21.5"
        x2="44.5"
        y2="114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#19DB15" />
        <stop offset="1" stopColor="#3CBD68" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level8ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 114}
    height={props.height ?? 61}
    style={props.style}
    viewBox="0 0 114 61"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20683)">
      <path
        d="M7.6 58C4.5072 58 1.97094 55.4865 2.27961 52.4091C3.5634 39.6103 9.22611 27.5779 18.402 18.402C28.9041 7.89998 43.1479 2 58 2C72.8521 2 87.0959 7.89998 97.598 18.402C106.774 27.5779 112.437 39.6103 113.72 52.4091C114.029 55.4865 111.493 58 108.4 58C105.307 58 102.836 55.483 102.451 52.4144C101.217 42.5922 96.7525 33.3958 89.6784 26.3216C81.2767 17.92 69.8817 13.2 58 13.2C46.1183 13.2 34.7232 17.92 26.3216 26.3216C19.2475 33.3958 14.7834 42.5922 13.5494 52.4144C13.1639 55.483 10.6928 58 7.6 58Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_di_5008_20683)">
      <path
        d="M7.6 58C4.5072 58 1.97097 55.4865 2.27972 52.4092C3.26665 42.5724 6.84504 33.1359 12.695 25.084C19.6462 15.5166 29.4478 8.39528 40.6951 4.74083C51.9423 1.08639 64.0577 1.08639 75.305 4.74084C84.7705 7.81637 93.2121 13.3473 99.7925 20.7254C101.851 23.0335 101.277 26.5577 98.7745 28.3756C96.2723 30.1935 92.7937 29.6098 90.6781 27.3538C85.5298 21.8642 79.0587 17.7369 71.844 15.3927C62.8462 12.4691 53.1538 12.4691 44.156 15.3927C35.1583 18.3162 27.317 24.0132 21.756 31.6672C17.2971 37.8044 14.4878 44.9472 13.5495 52.4144C13.1639 55.4831 10.6928 58 7.6 58Z"
        fill="url(#paint0_linear_5008_20683)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20683"
        x="2.25409"
        y="2"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20683" />
      </filter>
      <filter
        id="filter1_di_5008_20683"
        x="0.298771"
        y="0.696373"
        width="102.702"
        height="59.9109"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5008_20683" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5008_20683"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5008_20683" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20683"
        x1="105"
        y1="21.5"
        x2="44.5"
        y2="114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#19DB15" />
        <stop offset="1" stopColor="#3CBD68" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level9ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 114}
    height={props.height ?? 61}
    style={props.style}
    viewBox="0 0 114 61"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20677)">
      <path
        d="M7.6 58C4.5072 58 1.97094 55.4865 2.27961 52.4091C3.5634 39.6103 9.22611 27.5779 18.402 18.402C28.9041 7.89998 43.1479 2 58 2C72.8521 2 87.0959 7.89998 97.598 18.402C106.774 27.5779 112.437 39.6103 113.72 52.4091C114.029 55.4865 111.493 58 108.4 58C105.307 58 102.836 55.483 102.451 52.4144C101.217 42.5922 96.7525 33.3958 89.6784 26.3216C81.2767 17.92 69.8817 13.2 58 13.2C46.1183 13.2 34.7232 17.92 26.3216 26.3216C19.2475 33.3958 14.7834 42.5922 13.5494 52.4144C13.1639 55.483 10.6928 58 7.6 58Z"
        fill="currentColor"
      />
    </g>
    <g filter="url(#filter1_di_5008_20677)">
      <path
        d="M7.6 58C4.5072 58 1.97096 55.4863 2.27969 52.409C3.41478 41.0948 7.97504 30.3446 15.4173 21.6309C24.0769 11.4918 36.0701 4.77532 49.2397 2.68945C62.4093 0.603591 75.891 3.28527 87.2599 10.2521C97.0306 16.2396 104.69 25.0544 109.265 35.4641C110.51 38.2954 108.875 41.4698 105.933 42.4255C102.992 43.3813 99.8639 41.751 98.5489 38.9517C94.8455 31.0681 88.9034 24.395 81.4079 19.8017C72.3128 14.2282 61.5274 12.0829 50.9917 13.7516C40.456 15.4203 30.8615 20.7935 23.9338 28.9047C18.2246 35.5894 14.6354 43.7722 13.5495 52.4143C13.1639 55.483 10.6928 58 7.6 58Z"
        fill="url(#paint0_linear_5008_20677)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20677"
        x="2.25415"
        y="2"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20677" />
      </filter>
      <filter
        id="filter1_di_5008_20677"
        x="0.29871"
        y="0.696373"
        width="111.343"
        height="59.9109"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5008_20677" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5008_20677"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5008_20677" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20677"
        x1="105"
        y1="21.5"
        x2="44.5"
        y2="114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#19DB15" />
        <stop offset="1" stopColor="#3CBD68" />
      </linearGradient>
    </defs>
  </svg>
);

export const Level10ArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 116}
    height={props.height ?? 61}
    style={props.style}
    viewBox="0 0 116 61"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20679)">
      <path
        d="M7.6 58C4.5072 58 1.97094 55.4865 2.27961 52.4091C3.5634 39.6103 9.22611 27.5779 18.402 18.402C28.9041 7.89998 43.1479 2 58 2C72.8521 2 87.0959 7.89998 97.598 18.402C106.774 27.5779 112.437 39.6103 113.72 52.4091C114.029 55.4865 111.493 58 108.4 58C105.307 58 102.836 55.483 102.451 52.4144C101.217 42.5922 96.7525 33.3958 89.6784 26.3216C81.2767 17.92 69.8817 13.2 58 13.2C46.1183 13.2 34.7232 17.92 26.3216 26.3216C19.2475 33.3958 14.7834 42.5922 13.5494 52.4144C13.1639 55.483 10.6928 58 7.6 58Z"
        fill="black"
        fillOpacity="0.06"
      />
    </g>
    <g filter="url(#filter1_di_5008_20679)">
      <path
        d="M7.6 58C4.5072 58 1.971 55.4866 2.27977 52.4093C2.82521 46.9731 4.1643 41.6358 6.26275 36.5697C9.07701 29.7755 13.2019 23.6021 18.402 18.402C23.6021 13.2019 29.7755 9.07701 36.5697 6.26275C43.364 3.44848 50.646 2 58 2C65.354 2 72.636 3.44848 79.4303 6.26275C86.2245 9.07701 92.3979 13.2019 97.598 18.402C102.798 23.6021 106.923 29.7755 109.737 36.5697C111.836 41.6358 113.175 46.9731 113.72 52.4093C114.029 55.4866 111.493 58 108.4 58C105.307 58 102.836 55.4832 102.45 52.4145C101.952 48.4505 100.925 44.5624 99.3898 40.8558C97.1384 35.4204 93.8384 30.4817 89.6784 26.3216C85.5183 22.1616 80.5796 18.8616 75.1442 16.6102C69.7088 14.3588 63.8832 13.2 58 13.2C52.1168 13.2 46.2912 14.3588 40.8558 16.6102C35.4204 18.8616 30.4817 22.1616 26.3216 26.3216C22.1616 30.4817 18.8616 35.4204 16.6102 40.8558C15.0749 44.5624 14.0477 48.4505 13.5495 52.4145C13.1639 55.4832 10.6928 58 7.6 58Z"
        fill="url(#paint0_linear_5008_20679)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20679"
        x="2.25415"
        y="2"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20679" />
      </filter>
      <filter
        id="filter1_di_5008_20679"
        x="0.298832"
        y="0.696373"
        width="115.402"
        height="59.9109"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5008_20679" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5008_20679"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5008_20679" />
      </filter>
      <linearGradient
        id="paint0_linear_5008_20679"
        x1="105"
        y1="21.5"
        x2="44.5"
        y2="114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#19DB15" />
        <stop offset="1" stopColor="#3CBD68" />
      </linearGradient>
    </defs>
  </svg>
);

export const UnknownArcIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width={props.width ?? 112}
    height={props.height ?? 58}
    style={props.style}
    viewBox="0 0 112 58"
    fill="none"
  >
    <g filter="url(#filter0_i_5008_20689)">
      <path
        d="M5.6 56C2.5072 56 -0.0290604 53.4865 0.27961 50.4091C1.5634 37.6103 7.22611 25.5779 16.402 16.402C26.9041 5.89998 41.1479 1.1213e-06 56 0C70.8521 -1.1213e-06 85.0959 5.89998 95.598 16.402C104.774 25.5779 110.437 37.6103 111.72 50.4091C112.029 53.4865 109.493 56 106.4 56C103.307 56 100.836 53.483 100.451 50.4144C99.2166 40.5922 94.7525 31.3958 87.6784 24.3216C79.2767 15.92 67.8817 11.2 56 11.2C44.1183 11.2 32.7232 15.92 24.3216 24.3216C17.2475 31.3958 12.7834 40.5922 11.5494 50.4144C11.1639 53.483 8.69279 56 5.6 56Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_5008_20689"
        x="0.25415"
        y="0"
        width="111.492"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5008_20689" />
      </filter>
    </defs>
  </svg>
);
